import { Table } from "reactstrap";
import {
  BsFilter
} from "react-icons/bs";
import styles from './workspaceSelectTable.module.scss'
import { useEffect, useState } from "react";
import { BsFillCheckSquareFill } from 'react-icons/bs'
import { AiOutlineSearch } from 'react-icons/ai'
import { getLocalUser } from "../../../components/functions/utilities";
import { RestS } from "../../../rest/rest-service";

type Props = {
  reportIds: any,
  setReportIds: Function
}

const WorkspaceSelectTable = ({ reportIds, setReportIds }: Props) => {
  const currUser = getLocalUser()
  const [sortingData, setSortingData] = useState({
    by: '',
    type: 0     // 1 for decending and 0 for ascending
  })

  const [searchBarValue, setSearchBarValue] = useState('')
  const [data, setData] = useState<any>(null)

  useEffect(() => {
    console.log('data', data)
    console.log('reportIds data', reportIds)
  }, [data, reportIds])

  useEffect(() => {
    if (currUser.role != 'Agency') {
      RestS.getReportsByUserId(1, 1000, '', true)
        .then(res => {
          setData(res.reports.map(ele => {
            return { ...ele?.report, dataSource: ele?.latestVersion?.dataSource }
          }))
        })
        .catch(err => {
          console.log(err.data)
        })
    } else {
      RestS.getConnectedCompanies()
        .then(res => {
          setData(res)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }, [])

  const sorting = (field) => {
    const type = sortingData.by == field ? sortingData.type ^ 1 : 1
    const sortedData = data.sort((a, b) =>
      type ? a[field] < b[field] ? -1 : 1 : a[field] < b[field] ? 1 : -1
    )
    setData(sortedData)
    setSortingData({
      by: field,
      type: type
    })
  }

  const selectAll = () => {
    setReportIds(new Set(data.map(ele => ele.id)))
  }

  const allSelected = () => {
    return reportIds.size == data.length ? true : false
  }

  const showipName = (value) => {
    const ipNameArr = value.split(',')
    let str = ''
    if (ipNameArr.length === 1) {
      str = ipNameArr[0];
    } else if (ipNameArr.length === 2) {
      str = `${ipNameArr[0]} and ${ipNameArr[1]}`;
    } else {
      const firstTwo = ipNameArr.slice(0, 2);
      const othersCount = ipNameArr.length - 2;
      str = `${firstTwo.join(', ')} and ${othersCount} other${othersCount !== 1 ? 's' : ''}`
    }
    return str
  }

  return (
    <div>
      {/* <div className={styles.searchBar}>
                <AiOutlineSearch />
                <input placeholder="Search workspaces" onChange={(e)=>{setSearchBarValue(e.target.value)}} value={searchBarValue}/>
            </div> */}
      {
        data ?
          <>
            {
              currUser?.role != 'Agency' ?
                <div className={styles.tableContent}>
                  <Table borderless>
                    <thead className={styles.tableHeader}>
                      <tr>
                        <th>
                          {
                            !allSelected() ?
                              <div className={styles.checkBox} onClick={() => { selectAll() }}></div> :
                              <BsFillCheckSquareFill className={styles.svg} onClick={() => { setReportIds(new Set([])) }} />
                          }
                        </th>
                        <th>
                          Workspace Name
                          <BsFilter
                            className={`mx-2 j-cursor ${sortingData?.by == "initialReportName" &&
                              sortingData?.type
                              ? "rotate"
                              : ""
                              }`}
                            onClick={() => {
                              sorting("initialReportName");
                            }}
                          />
                        </th>
                        <th>
                          Data Source
                          <BsFilter
                            className={`mx-2 j-cursor ${sortingData?.by == "ipName" &&
                              sortingData?.type
                              ? "rotate"
                              : ""
                              }`}
                            onClick={() => {
                              sorting("ipName");
                            }}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        data.filter(ele => {
                          return ele.ipName.includes(searchBarValue) || ele.initialReportName.includes(searchBarValue)
                        })
                          .map((ele) => {
                            return (
                              <tr>
                                <td>
                                  {
                                    !reportIds.has(ele.id) ?
                                      <div className={styles.checkBox} onClick={() => {
                                        setReportIds(prev => new Set([...prev, ele.id]))
                                      }}></div> :
                                      <BsFillCheckSquareFill className={styles.svg} onClick={() => {
                                        setReportIds(prev => new Set([...prev].filter(x => x !== ele.id)))
                                      }} />
                                  }
                                </td>
                                <td>{ele.initialReportName}</td>
                                <td>{showipName(ele?.dataSource ? ele?.dataSource : '')}</td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </Table>
                </div> :
                <div className={styles.tableContent}>
                  <Table borderless>
                    <thead className={styles.tableHeader}>
                      <tr>
                        <th style={{ width: '50px' }}>
                          {
                            !allSelected() ?
                              <div className={styles.checkBox} onClick={() => { selectAll() }}></div> :
                              <BsFillCheckSquareFill className={styles.svg} onClick={() => { setReportIds(new Set([])) }} />
                          }
                        </th>
                        <th>
                          Brand
                          <BsFilter
                            className={`mx-2 j-cursor ${sortingData?.by == "name" &&
                              sortingData?.type
                              ? "rotate"
                              : ""
                              }`}
                            onClick={() => {
                              sorting("name");
                            }}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        data.filter(ele => {
                          return ele.name.includes(searchBarValue.toLowerCase())
                        })
                          .map((ele) => {
                            return (
                              <tr>
                                <td>
                                  {
                                    !reportIds.has(ele.id) ?
                                      <div className={styles.checkBox} onClick={() => {
                                        setReportIds(prev => new Set([...prev, ele.id]))
                                      }}></div> :
                                      <BsFillCheckSquareFill className={styles.svg} onClick={() => {
                                        setReportIds(prev => new Set([...prev].filter(x => x !== ele.id)))
                                      }} />
                                  }
                                </td>
                                <td>{ele.name}</td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </Table>
                </div>
            }
          </>
          : null
      }

    </div>
  )
}

export default WorkspaceSelectTable